import { connect, useSelector } from "react-redux";
import {
  useState,
  ChangeEvent,
  FormEvent,
  useEffect,
} from "react";
import { ApiError } from "components";
import MembershipPlanForm from "./components/MembershipPlanForm";
import {
  CreateMembershipPlanInput,
  CreateMembershipPlanInputError,
  MembershipPlansProps,
  stateStatusType,
} from "../../store/actionType";
import { createMembershipPlan, updateMembershipPlan } from "../../store/action";

type OwnProps = {
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
  membershipdata: MembershipPlansProps
};
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & OwnProps & StateProps;

const HandleUpdateMembershipPlan: React.FC<Props> = ({
  closeModal,
  onUpdateMembershipPlan,
  membershipdata
}) => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const [formData, setFormData] = useState<CreateMembershipPlanInput>({
  package_id: membershipdata.membership_details?.package.id, 
  membership_duration_id: membershipdata?.membership_duration_id,
  user_id: membershipdata?.user_id || "",
});

  const [error, setError] = useState<CreateMembershipPlanInputError>({});
  const [apiError, setApiError] = useState<string | null>(null);

  const membershipPlanState = useSelector(
    (state: any) => state.membershipPlan?.genericMembershipPlanState
  );

  const handleChange = (
    e: ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value, type } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "number" ? Number(value) : value,
    }));
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleSave = async (e: FormEvent) => {
    e.preventDefault();

    if (!formData?.package_id || !formData.membership_duration_id || !formData.user_id) {
      setError({
        membership_duration_id: formData.membership_duration_id ? "" : "Duration is required",
        user_id: formData.user_id ? "" : "User ID is required",
      });
      return;
    }

    setSubmitted(true);
    setLoading(true);

    try {
      const input:CreateMembershipPlanInput ={
        membership_duration_id:formData.membership_duration_id,
        user_id: formData.user_id
      }
      await onUpdateMembershipPlan(input);
    } catch (err) {
      console.error("Failed to create membership plan:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!membershipPlanState?.isLoading && submitted) {
      if (membershipPlanState?.status === stateStatusType.SUCCESS) {
        closeModal(false);
        setApiError(null);
        setSubmitted(false);
      }
      if (membershipPlanState?.status === stateStatusType.FAILED) {
        setApiError(membershipPlanState.error);
      }
    }
  }, [membershipPlanState, submitted, closeModal]);

  

  return (
    <div>
      <MembershipPlanForm
        handleSave={handleSave}
        formData={formData}
        handleChange={handleChange}
        error={error}
        loading={loading}
        header="Create Membership Plan"
        initialData={formData}
      />
      {apiError && <ApiError>{apiError}</ApiError>}
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  fetchMembershipDurationByPackageId:
    state.membershipDuration?.fetchmembershipDurationState,
});

const mapDispatchToProps = (dispatch: any) => ({
  onUpdateMembershipPlan: (input: CreateMembershipPlanInput) =>
    dispatch(updateMembershipPlan(input)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HandleUpdateMembershipPlan);
